module.exports = __webpack_public_path__ + "img/krotoski-lodz.9c24ac62.jpg";